import { type FC } from 'react';
import { Tooltip, IconButton, Badge } from '@mui/material';
import { FilterAltOutlined } from '@mui/icons-material';
import i18n from '@shared/config/i18n';
import type { SearchForm } from '@shared/tools/table.types';
import { Control } from '@unicorn/control';
import type { FormInstance } from '@unicorn/effector-form';
import * as Styled from './styled';

export type Props = {
  isFilterOpen?: boolean;
  isFiltersApply?: boolean;
  onOpenFilters?: () => any;
  hideFilterButton?: boolean;
  searchForm?: FormInstance<SearchForm>;
  leftActions?: React.ReactNode;
  rightActions?: React.ReactNode;
};

export const TableToolbar: FC<Props> = ({
  isFilterOpen,
  isFiltersApply,
  onOpenFilters,
  hideFilterButton,
  searchForm,
  leftActions,
  rightActions,
}) => (
  <Styled.Wrapper>
    {!hideFilterButton && (
      <Tooltip title={i18n.t('Filters')}>
        <div>
          <IconButton onClick={onOpenFilters} disabled={isFilterOpen}>
            <Badge variant="dot" color="error" invisible={!isFiltersApply}>
              <FilterAltOutlined />
            </Badge>
          </IconButton>
        </div>
      </Tooltip>
    )}
    {searchForm && (
      <Styled.SearchWrapper>
        <Control.Search name="search" form={searchForm} placeholder={i18n.t('search')!} />
      </Styled.SearchWrapper>
    )}
    {leftActions}
    <Styled.Greedy />
    {rightActions}
  </Styled.Wrapper>
);
